export default Object.freeze({
    OPERATOR: 'operator',
});
